const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x1bAa4282760850020415B2c7Dc84031Cebf5C375', // MSWAP
  busdAddress: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
  lpAddress: '0xCf2829E0eE2C4FE480eB2C2e74469C0F8163E7a6' // MSWAP-USDC LP
}

export default priceContracts